
import PiShareSettlement from "./children/pi-share-settlement.vue";
import PiShareDetail from "./children/pi-share-detail.vue";
import i18n from "@/config/i18n";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    PiShareSettlement,
    PiShareDetail
  }
})
export default class ShareSettlement extends Vue {
  private tabsList: object[] = [
    { title: i18n.t("splitSettlement.shareSettlement"), value: 1 },
    { title: i18n.t("splitSettlement.orderBreakdown"), value: 2 }
  ];
  private tabsActive = "1";
  public tabChange(data: string): void {
    this.tabsActive = data;
  }
}
